
import React, { useState, useEffect } from "react";
// import "../Assests/Scss/Dashboard.scss";
import axios from "axios";

import DropdownValues from "../components/Student/Reusablecomponents/DropDownValues";
import InternetChecking from "../components/Student/Reusablecomponents/Network";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoMdCloseCircleOutline } from "react-icons/io";
import axiosInstance from "../components/ReusableComponents/Axios";
import notify from "../components/ReusableComponents/ToastifyAlerts";

import { LuCalculator } from "react-icons/lu";
import { LuMicroscope } from "react-icons/lu";
import { IoBookOutline } from "react-icons/io5";
import { RiTranslate } from "react-icons/ri";
import { MdOutlineLanguage } from "react-icons/md";
import { GoArrowRight } from "react-icons/go";
import { GrammerDD } from "../components/ReusableComponents/QBEnglishDropdowns";
import "./Assessts/Styles/InputPracticetest.scss";
import * as Yup from "yup";
const InputPracticeTest = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [Grades, SetGrades] = useState([]);
  const [SGrade, SetSGrade] = useState();
  const [SSubject, SetSSubject] = useState();
  const [Topics, SeTopics] = useState([]);
  const [STopics, SetSTopics] = useState();

  const [Book, SetBook] = useState();
  const [Grammer, SetGrammer] = useState();
  const [BOptions, SetBOptions] = useState({
    MP: [],
    Poem: [],
    Lessons: [],
  });

  const [SBOption, SetSBOption] = useState({
    MP: "",
    Poem: "",
    Lesson: "",
  });
  const [AQErrors, SetAQErrors] = useState({});
  const [Message, SetMessage] = useState();
  const [OpenPT, SetOpenPT] = useState(false);

  const GetGrades = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=14&ParentLovId=0`);
      const FilterGrades = res.data.filter((item) => parseInt(item.lovDescription) >= 6 && parseInt(item.lovDescription) <= 10)
        .map((item) => ({
          display: parseInt(item.lovDescription), value: item.lovId
        }));
      SetGrades(FilterGrades);
    }
    catch (err) {
      console.log("err", err);
    }
  }
  useEffect(() => { GetGrades() }, [])
  const GeTopics = async (Sub, Grad) => {
    try {
      const res = await axiosInstance.get(`/PracticeTests/GetTopicsBySubjectAndGrade?SubjectId=${Sub || SSubject}&Grade=${Grad || SGrade}`);
      const formatdata = res.data.map((item) => ({
        display: item.topicName, value: item.topicId
      }));
      SeTopics(formatdata);
    }
    catch (err) {
      SeTopics([])
      console.log("err", err);
    }
  }

  const Subjects = [
    { display: "Mathematics", value: 1, Icon: <LuCalculator /> },
    { display: "Science", value: 2, Icon: <LuMicroscope /> },
    { display: "English", value: 3, Icon: <IoBookOutline /> },
    // { display: "Hindi", value: 4, Icon: <RiTranslate /> },
    // { display: "Telugu", value: 5, Icon: <MdOutlineLanguage /> },
  ];

  const NavigateQuestionPaper = () => {
    if (SSubject == 3) {
      LoadEnglish();
    } else {
      if (SGrade) {
        const AssessmentDetails = {
          SubjectId: SSubject,
          Grade: SGrade,
          TopicId: STopics || 0,
          SubjectName: Subjects.filter((Sub) => Sub.value == SSubject)?.[0]?.display,
          Book: Book || 0,
          MP: SBOption?.MP || 0,
          Poeam: SBOption?.Poem || 0,
          Lesson: SBOption?.Lesson || 0,
          Grammer: Grammer || 0,
        }
        localStorage.setItem("PAssessmentData", JSON.stringify(AssessmentDetails));
        navigate("/PracticeTest/PracticeAssessment");
        localStorage.setItem("ExamStartTime", new Date());
      }
      else {
        notify("Please select all the fields", "error");
      }
    }

  }
  const LoadEnglish = () => {
    if (SBOption.MP || SBOption.Poem || SBOption.Lesson) {
      const AssessmentDetails = {
        SubjectId: SSubject,
        Grade: SGrade,
        TopicId: STopics || 0,
        SubjectName: Subjects.filter((Sub) => Sub.value == SSubject)?.[0]?.display,
        Book: Book || 0,
        MP: SBOption?.MP || 0,
        Poeam: SBOption?.Poem || 0,
        Lesson: SBOption?.Lesson || 0,
        Grammer: Grammer || 0,
      }
      localStorage.setItem("PAssessmentData", JSON.stringify(AssessmentDetails));
      navigate("/PracticeTest/PracticeAssessment");
      localStorage.setItem("ExamStartTime", new Date());
    }
    else {
      notify("Please select any one of the fields - Main Reading, Poem, or Non-Detailed Lesson", "warning");
    }
  }
  const validationSchema = Yup.object().shape({
    SGrade: Yup.string().required("Grade is required"),
    SSubject: Yup.number().required("Subject is required"),
    STopics: Yup.string().when("SSubject", {
      is: () => SSubject !== 3,
      then: (schema) => Yup.string().required("Topic is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    Book: Yup.string().when("SSubject", {
      is: () => SSubject == 3,
      then: () => Yup.string().required("Book is required"),
      otherwise: () => Yup.string().notRequired(),
    }),

  });
  const YupValidation = () => {
    const AllFields = {
      SSubject, STopics, SGrade, Book
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        NavigateQuestionPaper();
        SetAQErrors({});
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };

  const GetBookDetails = async (Grad) => {
    try {
      const res = await axiosInstance.get(`/PracticeTests/GetBookDetailsByGrade?Grade=${Grad || SGrade}`);
      const formatdata = res.data.map((item) => ({
        display: item.bookName, value: item.bookId
      }));
      SeTopics(formatdata);
    }
    catch (err) {
      SeTopics([])
      console.log("err", err);
    }
  }
  const StoreSubject = (e) => {
    SetSSubject(e);
    if (e == 3) {
      GetBookDetails(SGrade)
    } else {
      GeTopics(e, SGrade);
    }
  }
  const StoreGrade = (e) => {
    SetSGrade(e);
    if (SSubject == 3) {
      GetBookDetails(e);
    } else {
      GeTopics(SSubject, e);
    }
  }
  const StoreBook = (e) => {
    SetBook(e);
    GetBookSubDropdowns(e);
  }
  const GetBookSubDropdowns = async (e) => {
    try {
      const res = await axiosInstance.get(`/PracticeTests/GetMainReadingsAndLessonsByBook?BookId=${e}`);
      const options = {
        MP: [],
        Poem: [],
        Lessons: [],
      };

      res.data.forEach((SBook) => {
        if (SBook.mainReadingLovId) {
          options.MP.push({
            display: SBook.mainReading,
            value: SBook.mainReadingLovId,
          });
        }

        if (SBook.mainReadingPoemLovId) {
          options.Poem.push({
            display: SBook.mainReadingPoem,
            value: SBook.mainReadingPoemLovId,
          });
        }

        if (SBook.lessonLovId) {
          options.Lessons.push({
            display: SBook.lessonName,
            value: SBook.lessonLovId,
          });
        }
      });

      SetBOptions(options);
    }
    catch (err) {
      SetBOptions({
        MP: [],
        Poem: [],
        Lessons: [],
      })
      console.log("err", err);
    }
  }
  return (
    <>
      <div className="p-4" >
        <InternetChecking />
        <div className="dflex JSBetween alignitems">
          <div className="IPTHeading">Start Your Practice Test</div>
          <button className="IPTButton Buttons" onClick={()=> navigate("/PracticeTest/TestReports")}>View test history</button></div>
        <div className="Card p-4">
          <div className="IPTSub-Heading">Select Grade</div>
          <div className="dflex gap-3  PTGrades">
            {Grades?.map((G) => (
              <div className={`${SGrade === G.value ? "SelectGrade" : "NotSelectGrade"} dflex alignitems`} onClick={() => { StoreGrade(G.value); }}
                style={{ alignContent: "center" }}>Grade {G.display}</div>
            ))}
          </div>
          {AQErrors?.SGrade && (<span className="error-message mt-2">{AQErrors?.SGrade}</span>)}
          <hr />

          <div className="IPTSub-Heading">Select Subject</div>
          <div className="dflex gap-3 PTSubjects">
            {Subjects?.map((S) => (
              <div className={`${SSubject == S.value ? "SelectGrade" : "NotSelectGrade"} dflex flexd-column gap-2 alignitems`}
                onClick={() => { StoreSubject(S.value); }} > {S.Icon}{S.display}</div>
            ))}

          </div>
          {AQErrors?.SSubject && (<span className="error-message mt-2">{AQErrors?.SSubject}</span>)}
          <hr />
          {SSubject !== 3 ?
            <>
              <div className="IPTSub-Heading">Select Topic</div>
              <DropdownValues className="IPTDropdown w-25" options={Topics} Displayname="Select Topic" onChange={(e) => { SetSTopics(e.target.value); }} />
              {AQErrors?.STopics && (<span className="error-message">{AQErrors?.STopics}</span>)}
            </> : <>
              <div className="IPTSub-Heading">Select Book</div>
              <DropdownValues className="IPTDropdown w-25" options={Topics} Displayname="Select Book" onChange={(e) => { StoreBook(e.target.value); }} />
              {AQErrors?.Book && (<span className="error-message">{AQErrors?.Book}</span>)}

              <div className="dflex JSBetween gap-3 mt-3">
                <div className="w-100">
                  <div className="IPTSub-Heading">Select Main Reading</div>
                  <DropdownValues className="IPTDropdown w-100" options={BOptions?.MP} Displayname="Select Main Reading" onChange={(e) => { SetSBOption({ ...SBOption, MP: e.target.value }) }} />
                </div>
                <div className="w-100">
                  <div className="IPTSub-Heading">Select Poem</div>
                  <DropdownValues className="IPTDropdown w-100" options={BOptions?.Poem} Displayname="Select Poem" onChange={(e) => { SetSBOption({ ...SBOption, Poem: e.target.value }) }} />
                </div>
                <div className="w-100">
                  <div className="IPTSub-Heading">Select Non-Detailed Lesson</div>
                  <DropdownValues className="IPTDropdown w-100" options={BOptions?.Lessons} Displayname="Select Lesson" onChange={(e) => { SetSBOption({ ...SBOption, Lesson: e.target.value }) }} />
                </div>

              </div>
              <div className="mt-3 w-100">
                <div className="IPTSub-Heading">Grammar</div>
                <GrammerDD SID="3" LID="38" className="IPTDropdown w-25 mt-2" StoreMSource={SetGrammer} SOption={Grammer}
                  onChange={(e) => { SetGrammer(e); }} Displayname="Select Grammar" /></div>
            </>}
        </div>

        <div className="dflex JSBetween mt-3">
          <div></div>
          <button className="IPTButton Buttons" onClick={() => YupValidation()}> Start Test  <GoArrowRight /> </button>
        </div>
      </div >
    </>
  );
};
export default InputPracticeTest;